var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cont-dlp-dashboard" }, [
    _c("h5", { staticClass: "title-section" }, [_vm._v("DLP Dashboard")]),
    _c(
      "article",
      { staticClass: "cont-iframe", attrs: { id: "SECTION" } },
      [
        _c(
          "b-card",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { sm: "12" } },
                  [
                    _c(
                      "a",
                      { attrs: { href: _vm.srcEmbebed, target: "_blank" } },
                      [
                        _vm._v("Open in new window"),
                        _c("i", { staticClass: "material-icons md-16" }, [
                          _vm._v("open_in_new"),
                        ]),
                      ]
                    ),
                    _c("b-embed", {
                      staticClass: "cont-frame",
                      attrs: {
                        type: "iframe",
                        src: _vm.srcEmbebed,
                        allowfullscreen: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }